import { Engine1Proxy, RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../Helpers/GlobalHelper';

let SolicitudManager = function () {

    var localValues = {};
    var solicitud = [];

    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     * @param {any} executionContext
     */
    function _guardarSolicitud(data, sagasCallback, viewCallback, executionContext) {

        let mode = 'create';

        createEstructuraBase(data);

        agregarCliente(data, mode);

        agregarDomicilio(data, mode);

        agregarFormaComunicacion(data, mode);

        crearSolicitud(data, executionContext, mode);

        setObjects(data, executionContext, null, mode);

        if (data.cuentaPropiaPorTarjeta)
            setObjectsList(data, executionContext, mode);

        if(data.Empresa && data.Empresa.esNueva){
            agregarEmpresaVisa(data,mode)
        }

        agregarCuentaTarjetaCredito(data, mode);
        switch (data.administradoraId) {
            case 1:
                agregarCuentaTarjetaCreditoVisa(data, mode);
                agregarCuentaBancaria(data, mode);
                break;
            case 2:
                agregarCuentaBancaria(data, mode);
                agregarCuentaTarjetaCreditoCabal(data, mode);
                break;
        } 

        let sagaName = '';
        switch (data.administradoraId) {
            case 1:
                if(data.Empresa && data.Empresa.esNueva ){
                    sagaName = 'SAGA_ALTA_CUENTA_VISA_CON_EMPRESA';
                }else{
                    sagaName = 'SAGA_ALTA_CUENTA_VISA';
                }
                break;
            case 2:
                sagaName = 'SAGA_ALTA_CUENTA_CABAL';
                break;
        }

        ejecutarSagas(localValues, sagaName, "ADMINEMPCUETAR", sagasCallback, viewCallback);

    }

    /**
     * 
     * @param {any} data
     * @param {any} viewCallBack
     */
    function _guardarSolicitudBorrador(data, viewCallBack) {

        let clienteCuitDni = undefined;
        let tarjetasNuevas;
        if (data.cliente.Cuit != undefined) {
            clienteCuitDni = data.cliente.Cuit;
        } else {
            clienteCuitDni = data.cliente.NumeroDocumento;
        }

        let localValues = {
            "SolicitudBorrador": {
                "Estado": JSON.stringify(data),
                "BancoClienteId": data.cliente.DatosClientes.ClienteBancoNumero,
                "SolicitudId": 0,
                "Administradora": data.administradoraId != undefined ? data.administradoraId : undefined,
                "Tipo": data.tipoEmpresa.EmpresaIndividuos != undefined ? data.tipoEmpresa.EmpresaIndividuos : undefined,
                "Empresa": undefined,
                "Cuenta": undefined,
                "TarjetasNuevas": 0,
                "BorradorId": solicitud.borradorId != undefined ? solicitud.borradorId : undefined
            }
        }

        Engine1Proxy.AddRuleRequests(localValues, 'GuardarEstadoBorrador', 'Tarjetas', 'SOLICITUD', 'Socios');
        Engine1Proxy.Execute(() => viewCallBack(), null, null, "SOLICITUD");
    }

    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     * @param {any} executionContext
     */
    function _modificarSolicitud(data, sagasCallback, viewCallback, executionContext) {

        let mode = 'edit';

        createEstructuraBase(data);

        agregarCliente(data, mode);

        agregarDomicilio(data, mode);

        ///agregarFormaComunicacionNueva(data, mode);
        agregarFormaComunicacion(data, mode);

        crearSolicitud(data, executionContext, mode);

        setObjects(data, executionContext, null, mode);

       /* setObjectsList(data, executionContext, mode);*/

       if(data.Empresa && data.DatosSolicitud.SolicitudTipoId == 1){
           agregarEmpresaVisa(data,mode)
       }

        agregarCuentaTarjetaCredito(data, mode);

        let sagaName = '';
        switch (data.administradoraId) {
            case 1:
                agregarCuentaTarjetaCreditoVisa(data, mode);
                if(data.Empresa && data.DatosSolicitud.SolicitudTipoId == 1){
                    sagaName = 'SAGA_MODIF_CUENTA_VISA_EMPRESA';
                }else{
                    if(Array.isArray(data.adicionalesEliminados) && data.adicionalesEliminados.length>0){
                        sagaName = 'SAGA_MODIF_CUENTA_VISA_CON_ELIMINADOS';
                    }else{
                        sagaName = 'SAGA_MODIF_CUENTA_VISA';
                    }
                }
                break;
            case 2:
                
                agregarCuentaTarjetaCreditoCabal(data, mode);
                    if(Array.isArray(data.adicionalesEliminados) && data.adicionalesEliminados.length>0){
                        sagaName = 'MODIF_CUENTA_CABAL_CON_ELIMINADOS';
                    }else{
                        sagaName = 'MODIF_CUENTA_CABAL';
                    }
                break;
        }

        agregarCuentaBancaria(data, mode);
        
        ejecutarSagas(localValues, sagaName, "ADMINEMPCUETAR", sagasCallback, viewCallback);

    }

    function _nuevaSolicitudAdicionales(data, sagasCallback, viewCallback, executionContext) {
        let sagaName = '';
        let soloAdicionales = true;

        //construyo solicitud
        switch (data.administradoraId) {
            case 1:
                {
                    sagaName = 'SAGA_MODIF_SOLICITUD_ADICIONALES_VISA';

                    let hoy = new Date();

                    localValues = {
                        "Solicitud":
                        {
                            "SolicitudEstadoId": 2,
                            "SolicitudTipoId": 3,
                            "FechaAlta": hoy,
                            "FechaEstado": hoy,
                            "LoginAlta": executionContext.login,
                            "AdministradoraId": data.administradoraId,
                        },
                        "TarjetaCredito": [],
                        "TarjetaCreditoVisa": []
                    }

                    agregarCuentaTarjetaCredito(data, "edit", soloAdicionales)

                    agregarCuentaTarjetaCreditoVisa(data, "edit", soloAdicionales)

                    break;
                }
            case 2:
                {
                    sagaName = 'SAGA_MODIF_SOLICITUD_ADICIONALES_CABAL';

                    let hoy = new Date();

                    localValues = {
                        "Solicitud":
                        {
                            "SolicitudEstadoId": 2,
                            "SolicitudTipoId": 3,
                            "FechaAlta": hoy,
                            "FechaEstado": hoy,
                            "LoginAlta": executionContext.login,
                            "AdministradoraId": data.administradoraId,
                        },
                        "TarjetaCredito": [],
                        "TarjetaCreditoCabal": [],
                        "CuentaTarjetaCreditoCabal": []
                    }

                    agregarCuentaTarjetaCredito(data, "edit", soloAdicionales)

                    agregarCuentaTarjetaCreditoCabal(data, "edit", soloAdicionales)

                    break;
                }
        }

        ejecutarSagas(localValues, sagaName, "ADMINEMPCUETAR", sagasCallback, viewCallback);
    }

    function _modificarSolicitudAdicionales(data, sagasCallback, viewCallback, executionContext) {
        let sagaName;
        let soloAdicionales =true;
        
        switch(data.administradoraId){
            case 1:{
                sagaName = 'SAGA_MODIF_SOLICITUD_ADICIONALES_VISA';

                localValues={
                    "Solicitud":{
                        "FechaUltimaModificacion" : new Date(),
                        "Id": data.SolicitudId,
                        "SolicitudEstadoId":2
                    },
                    "TarjetaCredito":[],
                    "TarjetaCreditoVisa":[]
                }

                agregarCuentaTarjetaCredito(data, "edit",soloAdicionales)

                agregarCuentaTarjetaCreditoVisa(data, "edit",soloAdicionales)

                break;
            }
            case 2:{
                sagaName = 'SAGA_MODIF_SOLICITUD_ADICIONALES_CABAL';

                localValues={
                    "Solicitud":{
                        "FechaUltimaModificacion" : new Date(),
                        "Id": data.SolicitudId,
                        "SolicitudEstadoId":2
                    },
                    "TarjetaCredito":[],
                    "TarjetaCreditoCabal":[],
                    "CuentaTarjetaCreditoCabal":[]
                }

                agregarCuentaTarjetaCredito(data, "edit",soloAdicionales)

                agregarCuentaTarjetaCreditoCabal(data, "edit",soloAdicionales)

                break;
            }
        }
        

        ejecutarSagas(localValues, sagaName, "ADMINEMPCUETAR", sagasCallback, viewCallback);
    }

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} extension
     * @param {any} mode
     */
    function setObjects(data, executionContext, extension, mode) {

        agregarCuentaTarjeta(data, extension, mode);

        switch (data.administradoraId) {
            case 1:
                agregarCuentaTarjetaVisa(data, extension, mode);
                break;
            case 2:
                agregarCuentaTarjetaCabal(data, extension, mode);
                break;
        }

        agregarCuentaTarjetaLimiteCompra(data, extension, mode);
    }

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} mode
     */
    //Segun este esquema, data deberia contener los datos asociados al titular, tanto los propios de la solicitud, como lo del resto de las tablas. 
    //Y dentro de cuentas adicionales, los datos asociados a cada titular en caso de un edit/delete
    function setObjectsList(data, executionContext, mode) {

        switch (mode) {
            case 'create':
                data.cuentasAdicionales.forEach(extension => {
                    setObjects(data, executionContext, extension, mode)
                });
                break;
            case 'edit':
                let cantEdiciones;

                if (data.cuentasAdicionales && data.cuentasAdicionales.length > 0) {
                    cantEdiciones = data.cuentasAdicionales.filter(adic => adic.Id != 0 && adic.Id).length;
                }

                if (!data.cuentaPropiaPorTarjeta && data.cuentaTarjetaList && data.cuentaTarjetaList.length == 1) {
                    editSoloDataTitular(data, executionContext, mode);
                } else if (!data.cuentaPropiaPorTarjeta && data.cuentasAdicionales) {
                    editTitularInsertAdicionales(data, executionContext, mode);
                } else if (!data.cuentaPropiaPorTarjeta && cantEdiciones > 1) {
                    editDataTitularDeleteAdicionales(data, executionContext, mode);
                } else {
                    editInsertTitularAdicionales(data, executionContext, mode);
                }
                break;
        }
    }

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} mode
     */
    //Copio los datos de los datos a data para que setObjects arme la estructura para enviar a sagas
    function editSoloDataTitular(data, executionContext, mode) {
        data = mapInfoTitularToData(data);
        setObjects(data, executionContext, null, mode);
    }

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} mode
     */
    //marcarAdicionalesParaEliminar inserta en localValues los registros de los adiciones a eliminar
    //luego setObjects inserta los registros del titular a actualizar
    function editDataTitularDeleteAdicionales(data, executionContext, mode) {

        data = mapInfoTitularToData(data);

        marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'CuentaTarjeta');
        marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'CuentaTarjetaLimiteCompra');
        marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'CuentaBancaria');
        marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'FormaComunicacion');

        switch (data.administradoraId) {
            case 1:
                marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'CuentaTarjetaVisa');
                break;
            case 2:
                marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'CuentaTarjetaCabal');
                break;
        }

       // setObjects(data, executionContext, null, mode);
    }

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} mode
     */
    //Ejecuto nuevo la funcion setObjectsList con mode create, para que genere la estructura a insertar de los adicionales
    // y a actualizar del titular. Los adicionales creados ya estan en data.cuentasAdicionales
    function editTitularInsertAdicionales(data, executionContext, mode) {

        data = mapInfoTitularToData(data);

        data.cuentasAdicionales.forEach(extension => {
            setObjects(data, executionContext, extension, mode)
        });
    }

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} mode
     */
    function editInsertTitularAdicionales(data, executionContext, mode) {
        data = mapInfoTitularToData(data);

        if (data.cuentasAdicionales && data.cuentasAdicionales.length > 1) {

            marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'CuentaBancaria');
            marcarAdicionalesParaEliminar(data.cuentasAdicionales, 'FormaComunicacion');

           /* data.cuentasAdicionales.forEach(extension => {
                setObjects(data, executionContext, extension, mode)
            });*/
        }
    }

    /**
     * 
     * @param {any} adicionales
     * @param {any} prop
     */
    function marcarAdicionalesParaEliminar(adicionales, prop) {
        adicionales.forEach(function (adicional) {
            if (adicional[prop]) {
                adicional[prop].forEach(function () {
                    elementid.Delete = 1;  //Seteo 1 para que sea eliminado
                    localValues.Solicitud[prop].push(element);
                })
            }
        })
    }

    /**
     * 
     * @param {any} data
     */
    //Funcion que copia los datos a data, incluidos los ids pre-existentes de las tablas relacionadas
    function mapInfoTitularToData(data) {

        for (var k in data.CuentaTarjeta) data[k] = data.cuentaTarjeta[k];
        for (var k in data.cuentaTarjetaVisa) data[k] = data.cuentaTarjetaVisa[k];
        for (var k in data.cuentaTarjetaLimiteCompra) data[k] = data.cuentaTarjetaLimiteCompra[k];
        for (var k in data.tarjetaCredito) data[k] = data.tarjetaCredito[k];
        for (var k in data.tarjetaCreditoVisa) data[k] = data.tarjetaCreditoVisa[k];
        for (var k in data.tarjetaCreditoCabal) data[k] = data.tarjetaCreditoCabal[k];

        return data;
    }

    /**
     * 
     * @param {any} data
     */
    function agregarCliente(data, mode) {

        var dateBirthday = convertDateBirthday(data.cliente.DatosClientes.FechaNac);
/*
        localValues.Cliente.ClienteBancoNumero = data.cliente.CliNum;
        localValues.Cliente.Apellido = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.ApellidoCompleto : null;
        localValues.Cliente.Nombre = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.NombreCompleto : null;
        localValues.Cliente.RazonSocial = data.cliente.DatosClientes.TipoPersona == "J" ? data.cliente.RAZON_SOCIAL : null;
        localValues.Cliente.FisicaJuridica = data.cliente.DatosClientes.TipoPersona;
        localValues.Cliente.TipoDocumentoId = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.TIPO_DOCUMENTO_ID : null;
        localValues.Cliente.NumeroDocumento = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.NUMERO_DOCUMENTO : null; //Si es persona jurídica NULL, pero si es persona física, consignar los dígitos centrales del número de CUIT
        localValues.Cliente.Cuit = data.cliente.Cuit;
        localValues.Cliente.FechaNacimiento = data.cliente.DatosClientes.TipoPersona == "F" ? new Date(dateBirthday.anioFechaNac, dateBirthday.mesFechaNac, dateBirthday.diaFechaNac) : GlobalHelper.DateBD();
        localValues.Cliente.CategoriaIvaId = data.cliente.tipoIva; //Id AdintaR de la condición ante IVA (inciso f)
        localValues.Cliente.TipoIibbId = data.cliente.IIBBId;; //Id AdintaR de la condición ante IIBB (inciso f).  NULL si no se recibió
        localValues.Cliente.NacionalidadId = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.Nacionalidad : null;
        localValues.Cliente.OcupacionId = data.cliente.ocupacionId; //Id AdintaR de la ocupación/actividad (inciso a)
        localValues.Cliente.EstadoCivilId = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.estadoCivilId : null;
        localValues.Cliente.Sexo = data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.DatosClientes.Sexo : null;
        localValues.Cliente.FechaAlta = GlobalHelper.DateBD();
        localValues.Cliente.FechaUltimaModificacion = GlobalHelper.DateBD();
        localValues.Cliente.CategoriaGananciasId = data.cliente.gananciasId; //Id AdintaR de la condición ante Ganancias (inciso f).  NULL si no se recibió.
        */

        let clienteTitular = {
            "ClienteBancoNumero": data.cliente.CliNum,
            "Apellido": data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.ApellidoCompleto : null,
            "Nombre": data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.NombreCompleto : null,
            "RazonSocial": data.cliente.DatosClientes.TipoPersona == "J" ? data.cliente.RAZON_SOCIAL : null,
            "FisicaJuridica": data.cliente.DatosClientes.TipoPersona,
            "TipoDocumentoId": data.cliente.DatosClientes.TipoPersona == "F" ? data.idTipoDocumentoDni : null,
            "NumeroDocumento": data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.NUMERO_DOCUMENTO : null, //Si es persona jurídica NULL, pero si es persona física, consignar los dígitos centrales del número de CUIT
            "Cuit": data.cliente.Cuit,
            "FechaNacimiento": new Date(dateBirthday.anioFechaNac, dateBirthday.mesFechaNac, dateBirthday.diaFechaNac),
            "CategoriaIvaId": data.cliente.tipoIva, //Id AdintaR de la condición ante IVA (inciso f)
            "TipoIibbId": data.cliente.IIBBId, //Id AdintaR de la condición ante IIBB (inciso f).  NULL si no se recibió
            "NacionalidadId": data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.Nacionalidad : null,
            "OcupacionId": data.cliente.ocupacionId, //Id AdintaR de la ocupación/actividad (inciso a)
            "EstadoCivilId": data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.estadoCivilId : null,
            "Sexo": data.cliente.DatosClientes.TipoPersona == "F" ? data.cliente.DatosClientes.Sexo : null,
            "FechaAlta": GlobalHelper.DateBD(),
            "FechaUltimaModificacion": GlobalHelper.DateBD(),
            "CategoriaGananciasId":data.cliente.gananciasId //Id AdintaR de la condición ante Ganancias (inciso f).  NULL si no se recibió.
        }
        localValues.Cliente.push(clienteTitular);

    
        if (data.cuentasAdicionales) {
            for (var i = 0; i < data.cuentasAdicionales.length; i++) {
                let dateBirthdayAdicional = convertDateBirthday(data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.FechaNac);
                
                let clienteAdicional = {
                    "ClienteBancoNumero": data.cuentasAdicionales[i].ClienteTarjetas.CliNum,
                    "Apellido": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.cuentasAdicionales[i].ClienteTarjetas.ApellidoCompleto : null,
                    "Nombre": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.cuentasAdicionales[i].ClienteTarjetas.NombreCompleto : null,
                    "RazonSocial": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "J" ? data.cuentasAdicionales[i].ClienteTarjetas.RAZON_SOCIAL : null,
                    "FisicaJuridica": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona,
                    "TipoDocumentoId": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.idTipoDocumentoDni : null,
                    "NumeroDocumento": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.cuentasAdicionales[i].ClienteTarjetas.NUMERO_DOCUMENTO : null, //Si es persona jurídica NULL, pero si es persona física, consignar los dígitos centrales del número de CUIT
                    "Cuit": data.cuentasAdicionales[i].ClienteTarjetas.Cuit,
                    "FechaNacimiento": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? new Date(dateBirthdayAdicional.anioFechaNac, dateBirthdayAdicional.mesFechaNac, dateBirthdayAdicional.diaFechaNac) : GlobalHelper.DateBD(),
                    "CategoriaIvaId": data.cuentasAdicionales[i].ClienteTarjetas.tipoIva, //Id AdintaR de la condición ante IVA (inciso f)
                    "TipoIibbId": data.cuentasAdicionales[i].ClienteTarjetas.IIBBId, //Id AdintaR de la condición ante IIBB (inciso f).  NULL si no se recibió
                    "NacionalidadId": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.cuentasAdicionales[i].ClienteTarjetas.Nacionalidad : null,
                    "OcupacionId": data.cuentasAdicionales[i].ClienteTarjetas.ocupacionId, //Id AdintaR de la ocupación/actividad (inciso a)
                    "EstadoCivilId": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.cuentasAdicionales[i].ClienteTarjetas.estadoCivilId : null,
                    "Sexo": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.TipoPersona == "F" ? data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.Sexo : null,
                    "FechaAlta": GlobalHelper.DateBD(),
                    "FechaUltimaModificacion": GlobalHelper.DateBD(),
                    "CategoriaGananciasId": data.cuentasAdicionales[i].ClienteTarjetas.gananciasId //Id AdintaR de la condición ante Ganancias (inciso f).  NULL si no se recibió.
                }

                localValues.Cliente.push(clienteAdicional);
            }

        }
    }

    /**
     * 
     * @param {any} data
     */
    function agregarDomicilio(data, mode) {
        let domicilio = data.DOMICILIOS_CLIENTE ? data.DOMICILIOS_CLIENTE : data.cliente.Domicilios[0] ? data.cliente.Domicilios[0].Direccion : {};

        //Se construye un array, debido a que en backend ahora se espera un array de domicilios por las modificaciones al dar de alta un cliente.
        localValues.Domicilio = [];

        //En caso que el domicilio sea nuevo, se agregará unicamente si fue seleccionado
        if (typeof (domicilio.length) != 'undefined')
        {
            domicilio.map(dom => {
                if (typeof(dom.Id) == "string" && (dom.Id == data.domicilioSeleccionadoId || dom.Id == data.comDomicilioSeleccionadoId))
                {
                    let tipoDomicilio = 0;
                    switch (dom.Id) {
                        case data.comDomicilioSeleccionadoId:
                            tipoDomicilio = 3;
                            break;
                        case data.domicilioSeleccionadoId:
                            tipoDomicilio = 1;
                            break;
                    }
                    let domInsert = {
                        "ClienteId": data.cliente.Id > 0 ? data.cliente.Id : null,
                        "TipoDomicilio": tipoDomicilio,
                        "Calle": dom.Calle,
                        "Numero": dom.Numero,
                        "Piso": dom.Piso,
                        "Departamento": dom.Depto,
                        "Localidad": dom.Localidad, //Localidad recibido
                        "Provincia": dom.Provincia,
                        "CodigoPostal": dom.CodPostal ? dom.CodPostal : dom.CodigoPostal,
                        "FechaAlta": GlobalHelper.DateBD(),
                        "FechaUltimaModificacion": GlobalHelper.DateBD(),
                        "LocalOficinaDepartamento": null,
                        "PaisId": dom.Pais,
                        "Activo": 1,
                        "DomicilioIdCore": dom.TipoDomicilio ? dom.TipoDomicilio : dom.CodigoDomicilio,
                        "CodigoGeograficoId": dom.CodigoGeografico,
                        "NuevoDomicilioUpdate": 1
                    };
                    localValues.Domicilio.push(domInsert);
                }
                //Descomentar al retomar tarea de codigos geograficos
                //else if (typeof (dom.Id) == "number" && (dom.Id == data.domicilioSeleccionadoId || dom.Id == data.comDomicilioSeleccionadoId)) {
                //    let tipoDomicilio = 0;
                //    switch (dom.Id) {
                //        case data.comDomicilioSeleccionadoId:
                //            tipoDomicilio = 3;
                //            break;
                //        case data.domicilioSeleccionadoId:
                //            tipoDomicilio = 1;
                //            break;
                //    }
                //    let domUpdate = {
                //        "ClienteId": data.cliente.Id > 0 ? data.cliente.Id : null,
                //        "TipoDomicilio": tipoDomicilio,
                //        "Calle": dom.Calle,
                //        "Numero": dom.Numero,
                //        "Piso": dom.Piso,
                //        "Departamento": dom.Depto,
                //        "Localidad": dom.Localidad, //Localidad recibido
                //        "Provincia": dom.Provincia,
                //        "CodigoPostal": dom.CodPostal ? dom.CodPostal : dom.CodigoPostal,
                //        "FechaAlta": GlobalHelper.DateBD(),
                //        "FechaUltimaModificacion": GlobalHelper.DateBD(),
                //        "LocalOficinaDepartamento": null,
                //        "PaisId": dom.Pais,
                //        "Activo": 1,
                //        "DomicilioIdCore": dom.TipoDomicilio ? dom.TipoDomicilio : dom.CodigoDomicilio,
                //        "CodigoGeograficoId": dom.CodGeografico ? dom.CodGeografico : dom.CodigoGeografico
                //    };
                //    localValues.Domicilio.push(domUpdate);
                //}
            })
        }

        if (typeof (domicilio) == 'undefined') {//en caso que obtenga un unico domicilio
            let domUpdate = {
                "ClienteId": data.cliente.Id > 0 ? data.cliente.Id : null,
                "TipoDomicilio": domicilio.TipoDomicilio,
                "Calle": domicilio.Calle,
                "Numero": domicilio.Numero,
                "Piso": domicilio.Piso,
                "Departamento": domicilio.Depto,
                "Localidad": domicilio.Localidad, //Localidad recibido
                "Provincia": domicilio.Provincia,
                "CodigoPostal": domicilio.CodPostal ? domicilio.CodPostal : domicilio.CodigoPostal,
                "FechaAlta": GlobalHelper.DateBD(),
                "FechaUltimaModificacion": GlobalHelper.DateBD(),
                "LocalOficinaDepartamento": null,
                "PaisId": domicilio.Pais,
                "Activo": 1,
                "DomicilioIdCore": domicilio.TipoDomicilio ? domicilio.TipoDomicilio : domicilio.CodigoDomicilio,
                "CodigoGeograficoId ": domicilio.CodigoGeografico
            };

            localValues.Domicilio.push(domUpdate);
        }

        /*
        localValues.Domicilio.ClienteId = data.cliente.Id > 0 ? data.cliente.Id : null;
        localValues.Domicilio.TipoDomicilio = domicilio.TipoDomicilio;
        localValues.Domicilio.Calle = domicilio.Calle;
        localValues.Domicilio.Numero = domicilio.Numero;
        localValues.Domicilio.Piso = domicilio.Piso;
        localValues.Domicilio.Departamento = domicilio.Depto;
        localValues.Domicilio.Localidad = domicilio.Localidad; //Localidad recibido
        localValues.Domicilio.Provincia = domicilio.Provincia;
        localValues.Domicilio.CodigoPostal = domicilio.CodPostal ? domicilio.CodPostal : domicilio.CodigoPostal;
        localValues.Domicilio.FechaAlta = GlobalHelper.DateBD();
        localValues.Domicilio.FechaUltimaModificacion = GlobalHelper.DateBD();
        localValues.Domicilio.LocalOficinaDepartamento = null;
        localValues.Domicilio.PaisId = domicilio.Pais;
        localValues.Domicilio.Activo = 1;
        localValues.Domicilio.DomicilioIdCore = domicilio.TipoDomicilio ? domicilio.TipoDomicilio : domicilio.CodigoDomicilio;
        localValues.Domicilio.CodigoGeograficoId = domicilio.CodigoGeografico;
        */
    }

    /**
     * 
     * @param {any} data
     */
    function agregarFormaComunicacionNueva(data) {

        let telFijo = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'TELFIJO')[0];
        let email = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'EMAIL')[0];

        var telFijoId = null;
        var emailId = null;

        if (data.administradoraId == 1) {
            telFijoId = telFijo.Id
            emailId = email.Id
        }

        if (data.administradoraId == 2) {
            telFijoId = telFijo.ID
            emailId = email.ID
        }

        for (var i = 0; i < data.cliente.MailsCliente; i++) {
            let formaComunicacion = {
                "Id": null,
                "TipoComunicacionId": email && emailId,
                "CuentaTarjetaId": null,
                "Contacto": data.cliente.MailsCliente[i].Mail,
                "ClienteId": null
            }

            localValues.FormaComunicacion.push(formaComunicacion);
        }
        for (var i = 0; i < data.cliente.TelefonosCliente; i++) {
            let formaComunicacion = {
                "Id": null,
                "TipoComunicacionId": telFijo && telFijoId,
                "CuentaTarjetaId": null,
                "Contacto": data.cliente.TelefonosCliente[i].Telefono,
                "ClienteId": null
            }

            localValues.FormaComunicacion.push(formaComunicacion);
        }
    }

    /**
     * 
     * @param {any} data
     */
    function createEstructuraBase(data) {

        localValues = {
            "Solicitud": {
                "SolicitudTipoId": null,
                "FechaAlta": null,
                "FechaUltimaModificacion": null,
                "FechaEstado": null,
                "FechaConfirmacion": null,
                "FechaInterfazSalida": null,
                "SolicitudEstadoId": null,
                "LoginAlta": null,
                "LoginConfirmacion": null,
                "CreaCuentaDescentralizada": null,
                "AdministradoraId": null,
                "PantallaActual": null,
                "OrigenAdm": 0,
                "SucursalId": null,
                "PromotorId": null,
                "CuentaTarjetaVisa": [],
                "CuentaTarjetaCabal": [],
                "CuentaTarjetaLimiteCompra": [],
                "CuentaTarjeta": [],
                "Interfaz": true,
                "CuentaBancaria": []
            },
            "TarjetaCredito": [],
            "TarjetaCreditoVisa": [],
            "CuentaTarjetaCreditoVisa": [],
            "TarjetaCreditoCabal": [],
            "CuentaTarjetaCreditoCabal": [],
            "FormaComunicacion": [],
            "CuentaBancaria": [],
            "Cliente": [],
            "Domicilio": {},
            "EmpresaVisa":{}
        }
    };

    /**
     * 
     * @param {any} data
     * @param {any} executionContext
     * @param {any} mode
     */
    function crearSolicitud(data, executionContext, mode) {

        var productoMarcaSeleccionado = null;

        if (data.GET_PRODUCTO_VISA_PRODUCTO_ID != null) {
            productoMarcaSeleccionado = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
            localValues.Solicitud.CreaCuentaDescentralizada = data.tipoEmpresa.EmpresaIndividuos == "E" ? data.cuentaPropiaPorTarjeta:null;
        } else {
            productoMarcaSeleccionado = data.GET_PRODUCTO_CABAL_PRODUCTO_ID;
            localValues.Solicitud.CreaCuentaDescentralizada = null
        }

        localValues.Solicitud.FechaConfirmacion = productoMarcaSeleccionado.SolicitudEstadoId == 3 ? GlobalHelper.DateBD() : null;
        localValues.Solicitud.SolicitudEstadoId = productoMarcaSeleccionado.SolicitudEstadoId;
        localValues.Solicitud.LoginConfirmacion = productoMarcaSeleccionado.SolicitudEstadoId == 3 ? executionContext.login : null;
        localValues.Solicitud.FechaEstado = GlobalHelper.DateBD();
        localValues.Solicitud.AdministradoraId = data.administradoraId;
        //localValues.Solicitud.SucursalId = data.sucursalCuentaPesosId & data.sucursalSeleccionadaId != parseInt(data.sucursalCuentaPesosId) ? parseInt(data.sucursalCuentaPesosId) : data.sucursalSeleccionadaId;// Cambiar por sucursalSeleccionadaId si o si
        localValues.Solicitud.SucursalId = data.sucursalSeleccionadaId;
        localValues.Solicitud.PromotorId = data.promotorSeleccionado ? data.promotorSeleccionado : null;

        switch (mode) {
            case 'create':
                localValues.Solicitud.SolicitudTipoId = data.Empresa && data.Empresa != null && data.Empresa.esNueva ? 1 : 2 ;
                localValues.Solicitud.FechaAlta = GlobalHelper.DateBD();
                localValues.Solicitud.LoginAlta = executionContext.login;
                break;
            case "edit":
                localValues.Solicitud.Id = data.SolicitudId;
                localValues.Solicitud.FechaUltimaModificacion = GlobalHelper.DateBD();
                localValues.Solicitud.SolicitudTipoId = data.DatosSolicitud.SolicitudTipoId;
                localValues.Solicitud.FechaAlta = data.DatosSolicitud.FechaAlta;
                localValues.Solicitud.LoginAlta = data.DatosSolicitud.LoginAlta;

                switch (data.administradoraId) {
                    case 1:
                        localValues.Solicitud.PantallaActual = null;
                        localValues.Solicitud.OrigenAdm = 0;
                        break;
                    case 2:
                        localValues.Solicitud.FechaEstado = GlobalHelper.DateBD();
                        localValues.Solicitud.FechaConfirmacion = data.SolicitudEstadoId == 3 ? new Date() : null;
                        localValues.Solicitud.PromotorId = data.DatosSolicitud.PromotorId ? data.DatosSolicitud.PromotorId : null;
                        localValues.Solicitud.SolicitudEstadoId = data.DatosSolicitud.SolicitudEstadoId;
                        break;
                }
        }
    }

    /**
     * 
     * @param {any} data
     * @param {any} extension
     * @param {any} mode
     */
    function agregarCuentaTarjeta(data, extension, mode) {

        var entidadBancaria = null;
        var producto = null;
        let domPostal = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'POSTAL')[0];
        let email = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'EMAIL')[0];
        let productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
        let bonificacion = null;
        //let CuentaBancariaId = mode == 'edit' && data.formaPagoId != 2 && data.GET_CUENTA_BANCARIA_POR_CUENTA_TARJETA && data.GET_CUENTA_BANCARIA_POR_CUENTA_TARJETA.filter(e => e.Id == data.cuentaPesosId).length > 0 ? data.GET_CUENTA_BANCARIA_POR_CUENTA_TARJETA.filter(e => e.Id == data.cuentaPesosId)[0].IdTabla : null;

        if (data.tipoEmpresa.EmpresaIndividuos == "E" && productoVisa) {
            let porcentajeBonificacionAlta = data.Empresa.bonificacionAlta ? data.Empresa.bonificacionAlta : data.empresa.PorcentajeBonificacionAlta;
            switch (porcentajeBonificacionAlta) {
                case 100:
                case "100":
                    bonificacion = "99";
                    break;
                default:
                    bonificacion = data.Empresa.bonificacionAlta;
                    break;
            }
        }
        if (data.tipoEmpresa.EmpresaIndividuos == "I" && productoVisa) {

            switch (productoVisa.CostoEmision) {

                case 'SC':
                    bonificacion = 'SC';
                    break;

                case 'BP':
                    bonificacion = data.porcentajeCostoEmision;
                    break;

                case 'SB':
                    bonificacion = '00';
                    break;

                case 'BT':
                    bonificacion = '99'
                    break;

                default:
                    break;
            }
        }

        if (data.GET_PRODUCTO_VISA_PRODUCTO_ID) { //visa
            producto = data.GET_PRODUCTO_VISA_PRODUCTO_ID.NuevosAtributos;
            entidadBancaria = data.GET_ATLAS_ENTIDAD_BANCARIA.filter(x => x.CodigoEquivalencia.toUpperCase() == 'VISA')[0];
        } else { //cabal
            producto = data.GET_PRODUCTO_CABAL_PRODUCTO_ID.NuevosAtributos;
            entidadBancaria = data.GET_ATLAS_ENTIDAD_BANCARIA.filter(x => x.CodigoEquivalencia.toUpperCase() == 'CABAL')[0];
        }
        let regexSoloDigitos = new RegExp("(^[0-9]+$)");

        let cuentaTarjeta = {
            "SucursalId": data.sucursalSeleccionadaId, //data.sucursalCuentaPesosId & data.sucursalSeleccionadaId !=  ? parseInt(data.sucursalCuentaPesosId) : data.sucursalSeleccionadaId,
            "GrupoAfinidadId": data.grupoAfinidadSeleccionadoId ? data.grupoAfinidadSeleccionadoId : null,
            "ModeloLiquidacionId": data.modeloLiquidacionId,
            "FormaPagoId": data.formaPagoId,
            "PromotorId": data.promotorSeleccionado ? data.promotorSeleccionado : null,
            "CarteraId": data.carteraId,
            "Descripcion": data.descripcionCuenta + (extension ? extension.Descripcion : ''),
            "FormaDebitoId": data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.some(forma => forma.Id == data.formaPagoId && forma.EsDebitoEnCuenta) ? data.formaDebitoId : null,
            "ProductoId": data.productoId,
            "TipoCorrespondenciaId": data.comDomicilioPostal ? (domPostal.Id ? domPostal.Id:domPostal.ID) : (email.Id ? email.Id : email.ID),
            "BonificacionAlta": bonificacion,
            "CuotasBonificacion": data.cuotasCostoEmisionSeleccionadas,
            "EmpresaId": data.tipoEmpresa.EmpresaIndividuos == "I" ? null : data.empresa.Id,
            "Planta": data.codigoPlanta ? data.codigoPlanta : null,
            "ModeloAutorizacionId": null,
            "DomicilioParticularId": !isNaN((data.domicilioSeleccionadoId)) && regexSoloDigitos.test(data.domicilioSeleccionadoId.toString()) ? data.domicilioSeleccionadoId : null,//si lo que hay es un string es porque no existía en nuestra base de datos
            "DomicilioCorrespondenciaId": !isNaN((data.comDomicilioSeleccionadoId)) && regexSoloDigitos.test(data.comDomicilioSeleccionadoId.toString()) ? data.comDomicilioSeleccionadoId : null,
            "SubTipoCuentaId": data.subTipoCuentaSeleccionadaId ? data.subTipoCuentaSeleccionadaId : null,
            "FechaAlta": null,
            "ClienteId": data.cliente.Id
            //"CuentaBancariaId": CuentaBancariaId
        };

        //Si es creacion, tomo los datos que dice la tarea de Ejecucion de Alta. Si es edicion, copio los datos desde data, que
        //previamente van a ser copiados por mapInfoTitularToData, ya que quizas esos datos se puedan modificar desde otra fuente en algun momento.
        switch (mode) {
            case 'create':
                cuentaTarjeta.CuentaTarjetaNumero = null;
                cuentaTarjeta.EntidadBancariaId = entidadBancaria.Id;
                cuentaTarjeta.AdministradoraId = data.administradoraId;
                cuentaTarjeta.SolicitudId = null;
                cuentaTarjeta.CuentaTarjetaEstadoId = 1;
                cuentaTarjeta.CuentaTipoId = data.tipoEmpresa.Id;
                break;
            case "edit":
                switch (data.administradoraId) {
                    case 1:
                        cuentaTarjeta.ClienteId = data.cliente.Id;
                        cuentaTarjeta.CuentaTarjetaNumero = data.CuentaTarjetaNumero;
                        cuentaTarjeta.EntidadBancariaId = data.GET_ATLAS_ENTIDAD_BANCARIA.find(x => x.CodigoEquivalencia.toUpperCase() == 'VISA').Id;
                        cuentaTarjeta.AdministradoraId = data.administradoraId;
                        cuentaTarjeta.SolicitudId = data.SolicitudId;
                        cuentaTarjeta.CuentaTarjetaEstadoId = 1;
                        cuentaTarjeta.CuentaTipoId = data.tipoEmpresa.Id;
                        //cuentaTarjeta.DomicilioParticularId = data.DatosSolicitud.DomicilioParticularId;
                        //cuentaTarjeta.DomicilioCorrespondenciaId = data.DatosSolicitud.DomicilioCorrespondenciaId;
                        break;
                    case 2:
                        cuentaTarjeta.SucursalId = data.DatosSolicitud.sucursalSeleccionadaId; //data.DatosSolicitud.sucursalCuentaPesosId & data.DatosSolicitud.sucursalSeleccionadaId != parseInt(data.DatosSolicitud.sucursalCuentaPesosId) ? parseInt(data.DatosSolicitud.sucursalCuentaPesosId) : data.DatosSolicitud.sucursalSeleccionadaId
                        cuentaTarjeta.GrupoAfinidadId = data.grupoAfinidadSeleccionadoId ? data.grupoAfinidadSeleccionadoId : null;
                        cuentaTarjeta.FormaPagoId = data.formaPagoId;
                        cuentaTarjeta.PromotorId = data.promotorSeleccionado ? data.promotorSeleccionado : null
                        cuentaTarjeta.CarteraId = data.carteraId;
                        cuentaTarjeta.Descripcion = data.descripcionCuenta;
                        cuentaTarjeta.FormaDebitoId = (data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID && data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID[0]) ? data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID[0].FormaDebitoId : null;
                        cuentaTarjeta.ProductoId = data.productoId;
                        //cuentaTarjeta.DomicilioParticularId = data.DatosSolicitud.DomicilioParticularId;
                        //cuentaTarjeta.DomicilioCorrespondenciaId = data.DatosSolicitud.DomicilioCorrespondenciaId;
                        cuentaTarjeta.CuentaTipoId = data.DatosSolicitud.CuentaTipoId;
                        cuentaTarjeta.EntidadBancariaId = entidadBancaria.Id;
                        cuentaTarjeta.AdministradoraId = data.administradoraId;
                        cuentaTarjeta.CuentaTarjetaEstadoId = 1;
                        break;
                }
                break;
        }

        if (mode == 'edit' && !extension)
            cuentaTarjeta.Id = data.CuentaTarjetaId;
        else if (mode == 'edit')
            cuentaTarjeta.Id = extension.CuentaTarjeta ? extension.CuentaTarjetaId : null;

        switch (data.administradoraId) {
            case 2:
                cuentaTarjeta.ModeloLiquidacionId = null;
                cuentaTarjeta.CuotasBonificacion = null;
                cuentaTarjeta.EmpresaId = null;
                cuentaTarjeta.Planta = null;
                cuentaTarjeta.SubTipoCuentaId = null;
                break;
        }

        localValues.Solicitud.CuentaTarjeta.push(cuentaTarjeta);
    }

    /**
     * 
     * @param {any} data
     * @param {any} extension
     * @param {any} mode
     */
    function agregarCuentaTarjetaVisa(data, extension, mode) {

        let CuentaTarjetaVisa = {
            "CuentaDenominacion": mode == "edit" ? data.DatosSolicitud.CuentaDenominacion :  (data.denominacion1 ? (data.denominacion1 + ' ' + data.denominacion2 + (extension ? (" / " + extension.Nombre + extension.Apellido) : ' ')) : data.cliente.RAZON_SOCIAL ?data.cliente.RAZON_SOCIAL : data.cliente.APELLIDO+" "+data.cliente.NOMBRE),
            "CategoriaCajeroVisaId": data.categoriaCajerosId,
            "IngresosBrutosCategoriaCodigoVisa": data.cliente.IIBBVisa,
            "IvaCategoriaCodigoVisa": data.cliente.ivaVisa,
            "Cuit": data.cliente.Cuit.split('-').join(''),
            "Email": data.email,
            "TelefonoDdn": null,
            "CuotasBonificacion": data.cuotasCostoEmisionSeleccionadas,
            "TelefonoNumero": null,
            "ComercializadoraCanalId": data.comercializadoraSeleccionadaId ? data.comercializadoraSeleccionadaId : null
        }

        switch (mode) {
            case 'create':
                CuentaTarjetaVisa.CuentaTarjetaId = null;
                CuentaTarjetaVisa.Telefono = null;
                break;
            case "edit":
                CuentaTarjetaVisa.Telefono = null;
                
                break;
        }

        if (mode == 'edit' && !extension) {
            CuentaTarjetaVisa.Id = data.CuentaTarjetaVisaId; //TODO
            CuentaTarjetaVisa.CuentaTarjetaId = data.CuentaTarjetaId;
        }
        else if (mode == 'edit') {
            CuentaTarjetaVisa.Id = extension.CuentaTarjetavisa ? extension.CuentaTarjetavisa.Id : null; //TODO
            CuentaTarjetaVisa.CuentaTarjetaId = extension.CuentaTarjeta ? extension.CuentaTarjeta.Id : null;
        }

        localValues.Solicitud.CuentaTarjetaVisa.push(CuentaTarjetaVisa);
    }

    /**
     * 
     * @param {any} data
     * @param {any} extension
     * @param {any} mode
     */
    function agregarCuentaTarjetaLimiteCompra(data, extension, mode) {

        let monedaId = null;
        var closest;
        var limiteCompraId;
        var producto = null;

        if(data.limiteCompra == "0" && data.limiteCompraId>0 && data.limiteCompraId != "0"){
            data.GET_LIMITE_COMPRA_PRODUCTO.map(limite=>{
                if(limite.ID==data.limiteCompraId) data.limiteCompra = limite.VALOR
            })
        }

        if (data.GET_PRODUCTO_VISA_PRODUCTO_ID) {
            producto = data.GET_PRODUCTO_VISA_PRODUCTO_ID.TipoLimiteIndividuos;
            monedaId = data.pesos ? data.GET_ATLAS_MONEDA.filter(mon => mon.CODIGO.toUpperCase() == 'PESO')[0].ID : (data.dolares ? data.GET_ATLAS_MONEDA.filter(mon => mon.CODIGO.toUpperCase() == 'DOLAR')[0].ID : null);
        } else if (data.GET_PRODUCTO_CABAL_PRODUCTO_ID) {
            producto = null;
            monedaId = data.GET_ATLAS_MONEDA.filter(mon => mon.CODIGO.toUpperCase() == 'PESO')[0].ID
        }

        if (extension) {

            let atlasLimiteCompra = 0

            data.GET_LIMITE_COMPRA_PRODUCTO.map(limite=>{
                if(limite.Id == data.limiteCompraId || limite.ID == data.limiteCompraId) atlasLimiteCompra = limite.Valor ? limite.Valor : limite.VALOR;
            })

            let mul = (extension.LimiteDeCompra ? extension.LimiteDeCompra : 100) * atlasLimiteCompra;

            closest = data.GET_LIMITE_COMPRA_PRODUCTO.map(lim => lim.Valor).reduce(function (prev, curr) {
                return (curr - mul > prev - mul && curr - mul <= 0) ? curr : prev;
            });
        }

        let CuentaTarjetaLimiteCompra = {
            "CuentaTarjetaId": null,
            "LimiteCompraId": data.cuentaPropiaPorTarjeta && extension ? data.GET_LIMITE_COMPRA_PRODUCTO.filter(limite => limite.Valor == closest)[0].Id : data.limiteCompraId,
            "LimiteFinanciacion": data.limiteFinanciacion,
            "LineaPrestamoId": data.GET_ATLAS_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS ? data.limitePrestamoId : null,
            "FactorLimiteCompraCuotas": data.administradoraId == 2 ? (data.CLCC ? data.CLCC : null):data.factorLimiteCompra ? data.factorLimiteCompra : null,
            "UsoLimites": producto != "undefined" ? producto : null,
            "ModalidadDistribucionLimiteId": data.modeloDistribucionId,
            "ImporteLimiteCompra": data.cuentaPropiaPorTarjeta && extension ? closest : data.limiteCompra,
            "MonedaId": monedaId
        }

        switch (data.administradoraId) {
            case 1:
                CuentaTarjetaLimiteCompra.Id = data.DatosSolicitud != null ? data.DatosSolicitud.CuentaTarjtaLimiteCompraId : null;
                break;
            case 2:
                CuentaTarjetaLimiteCompra.Id = data.DatosSolicitud != null ? data.DatosSolicitud.LimiteCompraId : null;
                CuentaTarjetaLimiteCompra.LineaPrestamoId = null;
                CuentaTarjetaLimiteCompra.UsoLimites = null;
                CuentaTarjetaLimiteCompra.ModalidadDistribucionLimiteId = null;
                break;
        }

        switch (mode) {
            case 'create':
                CuentaTarjetaLimiteCompra.CoeficienteAdelanto = null;
                CuentaTarjetaLimiteCompra.FechaModificacion = null;
                CuentaTarjetaLimiteCompra.UsuarioModificacion = null;
                break;
            case 'edit':

                switch (data.administradoraId) {
                    case 1:
                        CuentaTarjetaLimiteCompra.CoeficienteAdelanto = data.CoeficienteAdelanto;
                        CuentaTarjetaLimiteCompra.FechaModificacion = data.FechaModificacion;
                        CuentaTarjetaLimiteCompra.UsuarioModificacion = data.UsuarioModificacion;
                        break;
                    case 2:
                        CuentaTarjetaLimiteCompra.LimiteFinanciacion = data.limiteFinanciacion;
                        CuentaTarjetaLimiteCompra.FactorLimiteCompraCuotas = data.factorLimiteCompra ? data.factorLimiteCompra : null;
                        CuentaTarjetaLimiteCompra.ImporteLimiteCompra = data.cuentaPropiaPorTarjeta && extension ? closest : data.limiteCompra;
                        break;
                }

                break;
        }

        if (mode == 'edit' && !extension && data.administradoraId == 1) {
            //CuentaTarjetaLimiteCompra.Id = data.GET_LIMITE_COMPRA_PRODUCTO.length > 0 ? data.GET_LIMITE_COMPRA_PRODUCTO[0].ID : null;  //SE COMENTA PORQUE ESTA TRAYENDO EL LIMITECOMPRAID Y ES ERRONEO
            CuentaTarjetaLimiteCompra.CuentaTarjetaId = data.CuentaTarjetaId;
        }
        else if (mode == 'edit' && data.administradoraId == 1) {
            //CuentaTarjetaLimiteCompra.Id = extension.CuentaTarjetaLimiteCompra ? extension.CuentaTarjetaLimiteCompra.Id : null; //SE COMENTA PORQUE ESTA TRAYENDO EL LIMITECOMPRAID Y ES ERRONEO
            CuentaTarjetaLimiteCompra.CuentaTarjetaId = extension.CuentaTarjetaId ? extension.CuentaTarjetaId : null;
        }

        localValues.Solicitud.CuentaTarjetaLimiteCompra.push(CuentaTarjetaLimiteCompra);
    }

    /**
     * 
     * @param {any} data
     */
    function agregarCuentaBancaria(data, mode) {

        switch (mode) {
            case 'create':

                break;
            case "edit":

                break;
        }

        let formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formaPago => formaPago.FormaPagoId == data.formaPagoId)[0];
        let tipoCuentaBancariaId = formaPago.FormaPagoId;

        let sucursalesExistentes = data.GET_CUENTA_BANCARIA_POR_CUENTA_TARJETA

        let sucursalesPesos = data.SUCURSALES_CUENTAS_PESOS;
        let sucursalesDolares = data.SUCURSALES_CUENTAS_DOLARES;

        let sucurssalPesosId = 0
        let sucurssalDolaresId = 0

       /* if(formaPago.EsDebitoEnCuenta){
            let tipoCuenta = formaPago.Codigo.substring(3,5);

            data.GET_ATLAS_TIPO_CUENTA_BANCARIA.map(tipo=>{
                if(tipo.CODIGO == tipoCuenta && tipo.ADMINISTRADORAID == data.administradoraId) tipoCuentaBancariaId = tipo.ID
            })
        }*/

        
        let cuentaPesos = null;
        let monedaPesosId = data.GET_ATLAS_MONEDA.filter(mon => mon.CODIGO.toUpperCase() == 'PESO')[0].ID;

        let cuentaDolar = null;
        let monedaDolarId = data.GET_ATLAS_MONEDA.filter(mon => mon.CODIGO.toUpperCase() == 'DOLAR')[0].ID;

        data.cliente.clienteListaDocumentos.map(cuenta => {
            if (cuenta.Moneda == "80") cuentaPesos = cuenta;
            if (cuenta.Moneda != "80") cuentaDolar = cuenta;
        })

        sucursalesPesos.map(suc => {
            if (suc.VALOR_X == cuentaPesos.Sucursal) sucurssalPesosId = suc.Id
        })

        sucursalesDolares.map(suc => {
            if (suc.VALOR_X == cuentaDolar.Sucursal) sucurssalDolaresId = suc.Id
        })

        if (cuentaPesos && formaPago.EsDebitoEnCuenta) {
            let NumeroCuenta = cuentaPesos.Id.toString()//.padStart(6,"000000")
            if(NumeroCuenta.length <6){
                while(NumeroCuenta.length <6) NumeroCuenta = "0"+ NumeroCuenta;
            }
            
            let NumeroSubcuenta = cuentaPesos.SubCuenta.toString().padStart(3,"0")
            if(NumeroSubcuenta.length <2){
                while(NumeroSubcuenta.length <2) NumeroSubcuenta = "0"+ NumeroSubcuenta;
            }

            let NumeroTipoOperacion = cuentaPesos.TipoOperacion.toString()//.padStart(2,"00")
            if(NumeroTipoOperacion.length <2){
                while(NumeroTipoOperacion.length <2) NumeroTipoOperacion = "0"+ NumeroTipoOperacion;
            }

            sucurssalPesosId = data.sucursalCuentaPesosId && sucurssalPesosId != parseInt(data.sucursalCuentaPesosId) ? parseInt(data.sucursalCuentaPesosId) : sucurssalPesosId

            let NumeroPesos = NumeroCuenta + NumeroSubcuenta;
            let CuentaBancaria;
            //let cuentaAuxiliar = data.GET_CUENTA_BANCARIA_POR_CUENTA_TARJETA.filter(e => e.Id == data.cuentaPesosId);

            if (NumeroPesos == data.cuentaPesosId) {
                CuentaBancaria = {
                    "Id": mode == "edit" ? data.DatosSolicitud.CuentaBancariaId : null,
                    "Descripcion": null,
                    "Numero": NumeroPesos,
                    "SucursalId": sucurssalPesosId,
                    "TipoCuentaBancariaId": tipoCuentaBancariaId,
                    "CuentaTarjetaId": data.CuentaTarjetaId,
                    "MonedaId": monedaPesosId,
                    "Delete": false
                }
            } else {

                CuentaBancaria = {
                    "Id": mode == "edit" ? data.DatosSolicitud.CuentaBancariaId : null,
                    "Descripcion": null,
                    "Numero": NumeroPesos? NumeroPesos : data.cuentaPesosId,
                    "SucursalId": data.sucursalCuentaPesosId,
                    "TipoCuentaBancariaId": tipoCuentaBancariaId,
                    "CuentaTarjetaId": data.CuentaTarjetaId,
                    "MonedaId": monedaPesosId,
                    "Delete": false
                }
            }
            localValues.CuentaBancaria.push(CuentaBancaria);
            localValues.Solicitud.CuentaBancaria.push(CuentaBancaria);
        }else if(!formaPago.EsDebitoEnCuenta && mode == "edit" && data.DatosSolicitud.CuentaBancariaId){
            let CuentaBancaria = {
                "Id":data.DatosSolicitud.CuentaBancariaId,
                "Descripcion": null,
                "Numero": "0",
                "SucursalId": "0",
                "TipoCuentaBancariaId": tipoCuentaBancariaId,
                "CuentaTarjetaId": data.CuentaTarjetaId,
                "MonedaId": monedaPesosId,
                "Delete": true
            }
            localValues.CuentaBancaria.push(CuentaBancaria);
            localValues.Solicitud.CuentaBancaria.push(CuentaBancaria);
        }

        if (data.cuentaDolaresId && formaPago.EsDebitoEnCuenta) {
            let NumeroCuentaD = cuentaDolar.Id.toString().padStart(6,"000000")
            let NumeroSubcuentaD = cuentaDolar.SubCuenta.toString().padStart(2,"00")
            let NumeroTipoOperacionD = cuentaDolar.TipoOperacion.toString().padStart(2,"00")
            let NumeroDolares = NumeroCuentaD + NumeroSubcuentaD + NumeroTipoOperacionD;

            let CuentaBancaria = {
                "Id":mode =="edit" ? data.DatosSolicitud.CuentaBancariaId : null,
                "Descripcion": null,
                "Numero": NumeroDolares,
                "SucursalId": sucurssalDolaresId,
                "TipoCuentaBancariaId": tipoCuentaBancariaId,
                "CuentaTarjetaId": data.CuentaTarjetaId ? data.CuentaTarjetaId : null,
                "MonedaId": monedaDolarId,
                "Delete": false
            }

            localValues.CuentaBancaria.push(CuentaBancaria);
            localValues.Solicitud.CuentaBancaria.push(CuentaBancaria);
        }

    }

    function agregarEmpresaVisa(data, mode) {

        let entidadBancaria = data.GET_ATLAS_ENTIDAD_BANCARIA.filter(x => x.CodigoEquivalencia.toUpperCase() == 'VISA')[0];
        let codigoEmpresa = data.GET_CODIGO_EMPRESA_VISA[0].codigo;
        let empresa = data.Empresa
        let fechaTopeAgro = empresa.FechaTopeAgro;
        let categoriaIvaIdAlta = null
        let categoriaIvaCodigoAlta = null

        let subTipoSeleccionado = data.subTipoCuenta.find(subtipo => subtipo.RelacionId == data.subTipoCuentaSeleccionadaId);
        let permiteCuotas = data.tipoEmpresa.PermiteCuotas;
        let permiteAdelantos = subTipoSeleccionado.PermiteAdelantos;
        let reporteCuentaCentral = subTipoSeleccionado.ReporteCuentaCentral;
        let requiereFechaTope = subTipoSeleccionado.RequiereFechaTope;
        
        if(requiereFechaTope && fechaTopeAgro && fechaTopeAgro.includes("/")) {
            fechaTopeAgro = new Date(fechaTopeAgro.split("/")[2], fechaTopeAgro.split("/")[1] -1, fechaTopeAgro.split("/")[0]);
        }

        // Acá se valida que empresa.categoriaIVA tenga un valor almacenado para buscar entre las propiedades, sin distinguir entre
        // mayusculas y minusculas, para las propiedades "Id" y "Codigo"

        if(empresa.categoriaIVA){
            let key = Object.keys(empresa.categoriaIVA).find(k => k.toLowerCase() === 'id');
            categoriaIvaIdAlta = empresa.categoriaIVA[key] 
        }
        
        categoriaIvaIdAlta = !categoriaIvaIdAlta ? empresa.CategoriaIvaId : categoriaIvaIdAlta

        if(empresa.categoriaIVA){
            let key = Object.keys(empresa.categoriaIVA).find(k => k.toLowerCase() === 'codigo');
            categoriaIvaCodigoAlta = empresa.categoriaIVA[key] 
        }
            
        categoriaIvaCodigoAlta = !categoriaIvaCodigoAlta ? empresa.CategoriaIvaCodigoVisa : categoriaIvaCodigoAlta
        let domicilioCalleRecortado = empresa.domicilio ? empresa.domicilio.Direccion.Calle : empresa.DomicilioCalle;
        domicilioCalleRecortado = domicilioCalleRecortado ? domicilioCalleRecortado.slice(0, 30) : domicilioCalleRecortado;

        let EmpresaVisa ={
            "Id":mode == "edit" ? empresa.Id : null,
            "Codigo": mode == 'edit' ? empresa.Codigo : codigoEmpresa,
            "ClienteId":data.cliente.Id && data.cliente.Id >0  ? data.cliente.Id : null,
            "EntidadBancariaId": entidadBancaria.Id,//ver
            "EntidadBancariaCodigo": null,//ver
            "Denominacion": empresa.Denominacion && empresa.Denominacion.length > 30 ? empresa.Denominacion.substring(0, 30) : empresa.Denominacion,
            "Descripcion":empresa.Descripcion,
            "LimiteCompra":empresa.LimiteCompra,
            "EmpresaVisaTipoId":empresa.TipoEmpresaId ? empresa.TipoEmpresaId : empresa.EmpresaVisaTipoId ,
            "EmpresaVisaTipoCodigo": empresa.TipoEmpresaCodigo ? empresa.TipoEmpresaCodigo : null,            
            "PorcentajeBonificacionAlta":empresa.bonificacionAlta,
            "PorcentajeBonificacionRenovacion":empresa.bonificacionRenovacion,
            "VigenciaAlta":empresa.vigenciaDesdeAlta,
            "VigenciaRenovacion":empresa.vigenciaDesdeLaRenovacion,
            "PermiteAdelantos":permiteAdelantos && empresa.checkAdvance,
            "PermiteCuotas":permiteCuotas && empresa.checkPermiteCuotas,
            "TablaPreciosVisaId":empresa.empresaVisaPrecio.Id, 
            "TablaPreciosVisaCodigo":empresa.empresaVisaPrecio.Codigo,
            "TieneLimiteTransaccion":empresa.checkLimit,
            "GeneraNuevaClave":empresa.checkHomeBanking,
            "DomicilioBancoTipo":empresa.domicilio ? empresa.domicilio.Direccion.CodigoDomicilio : empresa.DomicilioBancoTipo,
            "DomicilioCalle": domicilioCalleRecortado,
            "DomicilioNumero": empresa.domicilio ? empresa.domicilio.Direccion.Numero : empresa.DomicilioNumero,
            "DomicilioPiso": empresa.domicilio ? (empresa.domicilio.Direccion.Piso ? empresa.domicilio.Direccion.Piso :null) : empresa.DomicilioPiso,
            "DomicilioLod": null,
            "DomicilioLodNumero": empresa.domicilio && empresa.domicilio.Direccion.Depto ? empresa.domicilio.Direccion.Depto : null,
            "DomicilioCodigoPostal": empresa.domicilio ? empresa.domicilio.Direccion.CodigoPostal :empresa.DomicilioCodigoPostal,
            "DomicilioCodigoGeografico":empresa.codeGeographic ? empresa.codeGeographic : empresa.DomicilioCodigoGeografico,
            //"DomicilioDepartamentoPartido": empresa.domicilio ? empresa.domicilio.Direccion.Partido : empresa.DomicilioDepartamentoPartido,
            "DomicilioDepartamentoPartido": empresa.domicilio ? (empresa.domicilio.Direccion.Localidad ? empresa.domicilio.Direccion.Localidad : empresa.domicilio.Direccion.Partido) : empresa.DomicilioDepartamentoPartido,
            "DestinatarioReportes":empresa.report ? empresa.report : empresa.DestinatarioReportes,
            "Telefono":empresa.domicilio ? empresa.domicilio.Telefono.Numero : empresa.Telefono,
            "CarteraId": empresa.cartera ? empresa.cartera.id : empresa.CarteraId,
            "CarteraCodigo":empresa.cartera ? empresa.cartera.codigo : empresa.CarteraCodigo,
            "Rubro1":null,
            "Rubro2":null,
            "Rubro3":null,
            "Rubro4":null,
            "Rubro5":null,
            "Rubro6":null,
            "Rubro7":null,
            "Rubro8":null,
            "Rubro9":null,
            "RubroIncluidoExcluido":null,//ver todo rubros
            "PermiteConsumosExterior":empresa.checkForeign,
            "GeneraReporteCuentaCentral":reporteCuentaCentral,
            "FechaTopeAgro": requiereFechaTope? fechaTopeAgro : null,
            "Cuit":data.cliente.Cuit,
            "CategoriaIvaId": mode == "edit" ? empresa.CategoriaIvaId : categoriaIvaIdAlta,
            "CategoriaIvaCodigoVisa": mode == "edit" ? empresa.CategoriaIvaCodigoVisa : categoriaIvaCodigoAlta,
            "CobraValorRenovacion":empresa.checkUpdateValue,
            "FechaTopeRenovacion": empresa.checkUpdateValue ? empresa.dateExpiration : null,
            "TomaGastosModeloLiquidacion":empresa.checkExpenses,
            "SolicitudId":data.SolicitudId && data.SolicitudId>0  ? data.SolicitudId:null,
            "EmpresaVisaEstadoId":empresa.EmpresaVisaEstadoId,
            "GastosEmisionResumen": empresa.GastosEmisionResumen ? empresa.GastosEmisionResumen.toString().replace(",",".") : null,
            "Listados":null,//ver
            "ServicioComprobantes":null,//ver
            "CantidadMaximaDias":empresa.CantidadMaximaDias,//ver
            "ValorSeguroCorporativa":null,//ver
            "DerechoAperturaImpuestos":null,
            "CantidadCuotasApertura":null,//ver
            "PermiteAdelantosAcreditacion":null,//ver
            "Afinidad":empresa.Afinidad,
            "ComercioMadre":null,//ver
            "GrabaPlasticoDistribucion":null,//ver
            "MarcaCajaChica":null,//ver
            "EsConfidencial":empresa.checkEsConfidencial,
            "SubProductoPrismaId": empresa.SubProductoPrismaId,
            "Email": empresa.EmailEmpresa,
        }

        localValues.EmpresaVisa = EmpresaVisa;

    }
    /**
     * 
     * @param {any} data
     * @param {any} mode
     */
    function agregarCuentaTarjetaCredito(data, mode, soloAdicionales) {
        
        let productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
        let bonificacion;
        var cuartaLinea;
        if(!soloAdicionales){
            if (productoVisa) {
                switch (productoVisa.CostoEmision) {
    
                    case 'SC':
                        bonificacion = 'SC';
                        break;
    
                    case 'BP':
                        bonificacion = data.porcentajeCostoEmision;
                        break;
    
                    case 'SB':
                        bonificacion = '00';
                        break;
    
                    case 'BT':
                        bonificacion = '99'
                        break;
    
                    default:
                        break;
                }
    
                cuartaLinea = productoVisa.TipoGrabadoCuartaLinea ? data.denominacionCuartaLinea : null
            }
    
            let CuentaTarjetaCredito = {
                "CuentaTarjetaId": null,
                "Denominacion": null,
                "TarjetaTipoId": data.GET_TARJETA_TIPO_BY_CUENTA_TIPO[0] ? data.GET_TARJETA_TIPO_BY_CUENTA_TIPO[0].TarjetaTipoId : data.GET_TARJETA_TIPO_BY_CUENTA_TIPO.TarjetaTipoId,
                "Bonificacion": bonificacion,
                "Cuotas": data.cuotasCostoEmisionSeleccionadas,
                "SolicitudId": null,
                "TarjetaCreditoEstadoId": 1,
                "ClienteId": data.cliente.Id,
                "CuartaLinea": cuartaLinea ? cuartaLinea : null,
                "DistribucionId": data.distribucionTitularId,
                "Id": null,
                "Cuit":data.cliente.Cuit,
                "Titular":true
            }
            
            if (data.administradoraId == 2) {//cabal
                CuentaTarjetaCredito.Bonificacion = null;
                CuentaTarjetaCredito.CuartaLinea = (data.grabadoCuartaLinea && data.grabadoCuartaLinea !="") ? data.grabadoCuartaLinea : null ;
                CuentaTarjetaCredito.Cuotas = null;
                CuentaTarjetaCredito.DistribucionId = null;
                CuentaTarjetaCredito.Denominacion = data.denominacion1 + '/' + data.denominacion2;
            }
    
            if (mode == 'create') {
                CuentaTarjetaCredito.Vigencia = null;
                CuentaTarjetaCredito.EstaBloqueada = 0;
                CuentaTarjetaCredito.TieneBaja = 0;
                CuentaTarjetaCredito.TarjetaBajaMotivoId = null;
                CuentaTarjetaCredito.FechaHabilitacion = null;
                CuentaTarjetaCredito.BIN = null;
                CuentaTarjetaCredito.Terminacion = null;
                CuentaTarjetaCredito.FechaVigenciaDesde = null;
                CuentaTarjetaCredito.FechaVigenciaHasta = null;
                CuentaTarjetaCredito.CategoriaTarjeta = 0;
                CuentaTarjetaCredito.Denominacion = data.denominacion1 + '/' + data.denominacion2;
            } else {
                if (data.administradoraId == 1) { //visa
                    CuentaTarjetaCredito.Denominacion = data.denominacion2 + '/' + data.denominacion1;
                    CuentaTarjetaCredito.CuentaTarjetaId = data.CuentaTarjetaId;
                    CuentaTarjetaCredito.CuentaTarjetaNumero = data.CuentaTarjetaNumero;
                    CuentaTarjetaCredito.CuentaTarjetaEstadoId = data.CuentaTarjetaEstadoId;
                    CuentaTarjetaCredito.Vigencia = data.Vigencia;
                    CuentaTarjetaCredito.SolicitudId = data.SolicitudId;
                    CuentaTarjetaCredito.EstaBloqueada = data.EstaBloqueada ? 1:0 ;
                    CuentaTarjetaCredito.TieneBaja = data.TieneBaja ? 1:0;
                    CuentaTarjetaCredito.TarjetaBajaMotivoId = data.TarjetaBajaMotivoId;
                    CuentaTarjetaCredito.FechaHabilitacion = data.FechaHabilitacion;
                    CuentaTarjetaCredito.BIN = data.BIN;
                    CuentaTarjetaCredito.Terminacion = data.Terminacion;
                    CuentaTarjetaCredito.FechaVigenciaDesde = data.FechaVigenciaDesde;
                    CuentaTarjetaCredito.FechaVigenciaHasta = data.FechaVigenciaHasta;
                    CuentaTarjetaCredito.CategoriaTarjeta = 0;
                    
                }
    
                if (data.administradoraId == 2) { //cabal
                    CuentaTarjetaCredito.Denominacion = data.cliente.ApellidoCompleto + "/" + data.cliente.NombreCompleto;
                    CuentaTarjetaCredito.TarjetaTipoId = data.GET_TARJETA_TIPO_BY_CUENTA_TIPO.TarjetaTipoId
                    CuentaTarjetaCredito.CuartaLinea = data.CuartaLinea ? data.CuartaLinea : null;
                    CuentaTarjetaCredito.CuentaTarjetaEstadoId = data.DatosSolicitud.CuentaTarjetaEstadoId;
                    CuentaTarjetaCredito.EstaBloqueada = data.EstaBloqueada ? 1:0;
                    CuentaTarjetaCredito.TieneBaja = data.TieneBaja ? 1:0;
                    CuentaTarjetaCredito.CategoriaTarjeta = 0;
                    CuentaTarjetaCredito.Denominacion = data.Denominacion;
                    CuentaTarjetaCredito.SolicitudId = data.SolicitudId;
                }
            }
    
            if (mode == 'edit') {
                CuentaTarjetaCredito.Id = !data.modificaTitular ? data.DatosSolicitud.tarjetasSolicitud[0].IdAdicional : data.cuentasAdicionales[0].IdAdicional;
                CuentaTarjetaCredito.CuentaTarjetaId = data.CuentaTarjetaId;
            }
    
            if(!data.Empresa || data.Empresa == null){
                localValues.TarjetaCredito.push(CuentaTarjetaCredito);
            }            
        }

        //a los adicionales creados se agregan los que puedan haber sido eliminados en una modificación
        if(!data.adicionalesEliminados){
            data.adicionalesEliminados=[];
        }

        if(!data.cuentasAdicionales || (Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length == 0)){
            if(data.adicionalesEliminados.length>0){
                data.cuentasAdicionales = data.adicionalesEliminados
            }
        }else{
            data.cuentasAdicionales = data.cuentasAdicionales.concat(data.adicionalesEliminados);
        }
        
        if(Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length > 0 ){
            
            for(var i=0;i<data.cuentasAdicionales.length;i++){
                if (!data.cuentasAdicionales[i].ClienteTarjetas)
                    continue;

                let productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
                let bonificacion;
                var cuartaLinea;

                if(!data.cuentasAdicionales[i].Titular && data.cuentasAdicionales[i].ClienteTarjetas){
                    if (data.tipoEmpresa.EmpresaIndividuos == "I" && productoVisa) {
                        switch (productoVisa.CostoEmision) {
    
                            case 'SC':
                                bonificacion = 'SC';
                                break;
    
                            case 'BP':
                                bonificacion = data.cuentasAdicionales[i].PorcentajeEmision;
                                break;
    
                            case 'SB':
                                bonificacion = '00';
                                break;
    
                            case 'BT':
                                bonificacion = '99'
                                break;
    
                            default:
                                break;
                        }
    
                        cuartaLinea = productoVisa.TipoGrabadoCuartaLinea ? data.cuentasAdicionales[i].denominacionCuartaLinea : null

                    }

                    if (data.tipoEmpresa.EmpresaIndividuos == "E" && productoVisa) {
                        let porcentajeBonificacionAlta = data.Empresa.bonificacionAlta ? data.Empresa.bonificacionAlta : data.empresa.PorcentajeBonificacionAlta;
                        switch (porcentajeBonificacionAlta) {
                            case 100:
                            case "100":
                                bonificacion = "99";
                                break;
                            default:
                                bonificacion = porcentajeBonificacionAlta.toString();
                                break;
                        }
                    }

                    if(data.esCuentaExistente){
                        //se agrega esta condición porque en este caso puede que el producto ya no exista o no esté vigente
                        cuartaLinea =  data.cuentasAdicionales[i].denominacionCuartaLinea ? data.cuentasAdicionales[i].denominacionCuartaLinea : null
                    }
    
                    let CuentaTarjetaCreditoAdicional = {
                        "CuentaTarjetaId": data.cuentasAdicionales[i].ClienteTarjetas.CuentaTarjetaId,
                        "Denominacion": null,
                        "TarjetaTipoId": data.GET_TARJETA_TIPO_BY_CUENTA_TIPO && data.GET_TARJETA_TIPO_BY_CUENTA_TIPO[0] ? data.GET_TARJETA_TIPO_BY_CUENTA_TIPO[0].TarjetaTipoId:null,
                        "Bonificacion": bonificacion,
                        "Cuotas": data.cuentasAdicionales[i].cuotasEmision ? data.cuentasAdicionales[i].cuotasEmision : data.cuentasAdicionales[i].CuotasEmision,
                        "SolicitudId": null,
                        "TarjetaCreditoEstadoId": 1,
                        "ClienteId": data.cuentasAdicionales[i].ClienteTarjetas.Id,
                        "CuartaLinea": cuartaLinea ? cuartaLinea : null,
                        "DistribucionId": data.cuentasAdicionales[i].CodigoDistribucionId ? data.cuentasAdicionales[i].CodigoDistribucionId : data.distribucionTitularId,
                        "Id": null,
                        "Cuit": data.cuentasAdicionales[i].ClienteTarjetas.Cuit,
                        "Titular":false
                    }
                    
                    if (data.administradoraId == 2) {//cabal
                        CuentaTarjetaCreditoAdicional.Bonificacion = null;
                        CuentaTarjetaCreditoAdicional.CuartaLinea = data.cuentasAdicionales[i].denominacionCuartaLinea ? data.cuentasAdicionales[i].denominacionCuartaLinea : null ;
                        CuentaTarjetaCreditoAdicional.Cuotas = null;
                        CuentaTarjetaCreditoAdicional.DistribucionId = null;
                        CuentaTarjetaCreditoAdicional.Denominacion = data.cuentasAdicionales[i].Apellido + '/' + data.cuentasAdicionales[i].Nombre;
                    }
                    
                    if (mode == 'create') {
                        CuentaTarjetaCreditoAdicional.Vigencia =  data.cuentasAdicionales[i].vigenciaTemporalId ? data.cuentasAdicionales[i].vigenciaTemporalId:null;                        ;
                        CuentaTarjetaCreditoAdicional.EstaBloqueada = 0;
                        CuentaTarjetaCreditoAdicional.TieneBaja = 0;
                        CuentaTarjetaCreditoAdicional.TarjetaBajaMotivoId = null;
                        CuentaTarjetaCreditoAdicional.FechaHabilitacion = null;
                        CuentaTarjetaCreditoAdicional.BIN = null;
                        CuentaTarjetaCreditoAdicional.Terminacion = null;
                        CuentaTarjetaCreditoAdicional.FechaVigenciaDesde = null;
                        CuentaTarjetaCreditoAdicional.FechaVigenciaHasta = null;
                        CuentaTarjetaCreditoAdicional.CategoriaTarjeta = data.tipoEmpresa.EmpresaIndividuos == "E" ? "E" : 1;
                        CuentaTarjetaCreditoAdicional.Denominacion =data.cuentasAdicionales[i].Apellido + '/' + data.cuentasAdicionales[i].Nombre;
                    } else {
                        if (data.administradoraId == 1) { //visa
							CuentaTarjetaCreditoAdicional.Denominacion = data.cuentasAdicionales[i].Apellido + "/" + data.cuentasAdicionales[i].Nombre;
                            //CuentaTarjetaCreditoAdicional.CuentaTarjetaId = data.CuentaTarjetaId;
                            CuentaTarjetaCreditoAdicional.CuentaTarjetaNumero = data.CuentaTarjetaNumero;
                            CuentaTarjetaCreditoAdicional.CuentaTarjetaEstadoId = soloAdicionales ? 3 :  data.CuentaTarjetaEstadoId;
                            CuentaTarjetaCreditoAdicional.Vigencia = data.cuentasAdicionales[i].vigenciaTemporalId ? data.cuentasAdicionales[i].vigenciaTemporalId:null;
                            CuentaTarjetaCreditoAdicional.SolicitudId = data.SolicitudId;
                            CuentaTarjetaCreditoAdicional.EstaBloqueada = data.cuentasAdicionales[i].EstaBloqueada ? 1:0;
                            CuentaTarjetaCreditoAdicional.TieneBaja = data.cuentasAdicionales[i].TieneBaja ? 1:0;
                            CuentaTarjetaCreditoAdicional.TarjetaBajaMotivoId = data.cuentasAdicionales[i].TarjetaBajaMotivoId;
                            CuentaTarjetaCreditoAdicional.FechaHabilitacion = soloAdicionales ? null : data.cuentasAdicionales[i].FechaHabilitacion;
                            CuentaTarjetaCreditoAdicional.BIN = soloAdicionales ? null : data.cuentasAdicionales[i].BIN;
                            CuentaTarjetaCreditoAdicional.Terminacion = soloAdicionales ? null : data.cuentasAdicionales[i].Terminacion;
                            CuentaTarjetaCreditoAdicional.FechaVigenciaDesde = data.cuentasAdicionales[i].FechaVigenciaDesde;
                            CuentaTarjetaCreditoAdicional.FechaVigenciaHasta = data.cuentasAdicionales[i].FechaVigenciaHasta;
                            //CuentaTarjetaCreditoAdicional.CategoriaTarjeta = data.cuentasAdicionales[i].EsAdicional == "0" ? data.tipoEmpresa.EmpresaIndividuos == "E" ? "E" : 1 : 0;
                            CuentaTarjetaCreditoAdicional.CategoriaTarjeta = data.tipoEmpresa.EmpresaIndividuos == "E" ? "E" : 1
                            CuentaTarjetaCreditoAdicional.Delete = data.cuentasAdicionales[i].Delete ? data.cuentasAdicionales[i].Delete : null;
                            CuentaTarjetaCreditoAdicional.Id = data.cuentasAdicionales[i].IdAdicional;
                        }
    
                        if (data.administradoraId == 2) { //cabal
                            CuentaTarjetaCreditoAdicional.Denominacion = data.cuentasAdicionales[i].ClienteTarjetas.Apellido + "/" + data.cuentasAdicionales[i].ClienteTarjetas.Nombre;
                            CuentaTarjetaCreditoAdicional.TarjetaTipoId = data.GET_TARJETA_TIPO_BY_CUENTA_TIPO.TarjetaTipoId
                            CuentaTarjetaCreditoAdicional.CuartaLinea = data.cuentasAdicionales[i].denominacionCuartaLinea ? data.cuentasAdicionales[i].denominacionCuartaLinea : null;
                            CuentaTarjetaCreditoAdicional.CuentaTarjetaEstadoId = data.DatosSolicitud.CuentaTarjetaEstadoId;
                            CuentaTarjetaCreditoAdicional.EstaBloqueada = data.cuentasAdicionales[i].EstaBloqueada ? 1:0;
                            CuentaTarjetaCreditoAdicional.TieneBaja = data.cuentasAdicionales[i].TieneBaja ? 1:0;
                            CuentaTarjetaCreditoAdicional.CategoriaTarjeta = data.cuentasAdicionales[i].EsAdicional== "0" ? 0: 1;
                            CuentaTarjetaCreditoAdicional.Denominacion = data.cuentasAdicionales[i].Apellido + '/' + data.cuentasAdicionales[i].Nombre;
                            CuentaTarjetaCreditoAdicional.Delete = data.cuentasAdicionales[i].Delete && data.cuentasAdicionales[i].Delete;
                            CuentaTarjetaCreditoAdicional.Id = data.cuentasAdicionales[i].IdAdicional;
                            CuentaTarjetaCreditoAdicional.SolicitudId = data.SolicitudId;
                        }
                    }
    
                    if (mode == 'edit') {
                        CuentaTarjetaCreditoAdicional.CuentaTarjetaId = CuentaTarjetaCreditoAdicional.CuentaTarjetaId == null ? data.CuentaTarjetaId : CuentaTarjetaCreditoAdicional.CuentaTarjetaId;
                    }
    
                    localValues.TarjetaCredito.push(CuentaTarjetaCreditoAdicional);
                }

            }
        }
    }

    /**
     * 
     * @param {any} data
     */
    function agregarFormaComunicacion(data, mode) {

        switch (mode) {
            case 'create':

                break;
            case "edit":

                break;
        }

        let telFijo = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'TELFIJO')[0];
        let celular = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'CELULAR')[0];
        let email = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'EMAIL')[0];

        var telFijoId = null;
        var celullarId = null;
        var emailId = null;

        if (data.administradoraId == 1) {
            telFijoId = telFijo.Id
            celullarId = celular.Id
            emailId = email.Id
        }

        if (data.administradoraId == 2) {
            telFijoId = telFijo.ID
            celullarId = celular.ID
            emailId = email.ID
        }

        //localValues.FormaComunicacion = [];

        let telefonoGuardado= null;
        let celularGuardado= null;
        let mailGuardado= null;

        if(mode == "edit"){
            data.DatosSolicitud.Comunicacion.map(forma=>{
                if(forma.codigoTipoComunicacion.toUpperCase() =='TELFIJO' ) telefonoGuardado = JSON.parse(JSON.stringify(forma))
                if(forma.codigoTipoComunicacion.toUpperCase() =='CELULAR' ) celularGuardado = JSON.parse(JSON.stringify(forma))
                if(forma.codigoTipoComunicacion.toUpperCase() =='EMAIL') mailGuardado = JSON.parse(JSON.stringify(forma))
            })
        }

        if (data.telefonoSeleccionado) {

            let telefonoFijo = {
                "Id": telefonoGuardado ? telefonoGuardado.FormaComunicacionId : null,
                "TipoComunicacionId": telFijo && telFijoId,
                "CuentaTarjetaId": mode == "edit" ? data.CuentaTarjetaId : null,
                "Contacto": telefonoGuardado ? telefonoGuardado.Contacto : data.telefonoSeleccionado,
                "ClienteId": data.cliente.Id
            }

            localValues.FormaComunicacion.push(telefonoFijo);
        }

        if (data.celularSeleccionado) {
           

            let telefonoCelular = {
                "Id": celularGuardado ? celularGuardado.FormaComunicacionId : null,
                "TipoComunicacionId": celular && celullarId,
                "CuentaTarjetaId": mode == "edit" ? data.CuentaTarjetaId : null,
                "Contacto": celularGuardado ? celularGuardado.Contacto : data.celularSeleccionado,
                "ClienteId": data.cliente.Id
            }

            localValues.FormaComunicacion.push(telefonoCelular);
        }

        if (data.email && data.email !="") {

            let contactoEmail = {
                "Id": mailGuardado ? mailGuardado.FormaComunicacionId : null,
                "TipoComunicacionId": email && emailId,
                "CuentaTarjetaId": mode == "edit" ? data.CuentaTarjetaId : null,
                "Contacto": data.email,
                "ClienteId": data.cliente.Id
            }

            localValues.FormaComunicacion.push(contactoEmail);
        }

        if(mode == "edit" && mailGuardado && data.email ==""){
            let contactoEmailBorrar = {
                "Id": mailGuardado.FormaComunicacionId,
                "TipoComunicacionId": email && emailId,
                "CuentaTarjetaId": data.CuentaTarjetaId,
                "Contacto": data.email,
                "ClienteId": data.cliente.Id,
                "Delete":true
            }

            localValues.FormaComunicacion.push(contactoEmailBorrar);
        }

    }

    /**
     * 
     * @param {any} data
     * @param {any} mode
     */
    function agregarCuentaTarjetaCreditoVisa(data, mode, soloAdicionales) {

        if(!soloAdicionales){
            var dateBirthday = convertDateBirthday(data.cliente.DatosClientes.FechaNac);
            
            let CuentaTarjetaCreditoVisa = {
                "Id": data.TarjetaCreditoVisaId,
                "TarjetaCreditoId": null,
                "DocumentoTipoCodigoVisa": data.cliente ? data.cliente.documentoCodigoVisa : null,
                "DocumentoNumero": data.cliente ? data.cliente.NUMERO_DOCUMENTO : null,
                "NacionalidadCodigoVisa": data.cliente ? data.cliente.nacionalidadVisa : null,
                "SexoCodigoVisa": data.cliente ? data.cliente.DatosClientes.Sexo : null,
                "EstadoCivilCodigoVisa": data.cliente ? data.cliente.estadoCivilVisa : null,
                "FechaNacimiento": data.cliente ? new Date(dateBirthday.anioFechaNac, dateBirthday.mesFechaNac, dateBirthday.diaFechaNac) : null,
                "OcupacionCodigoVisa": data.cliente ? data.cliente.ocupacionVisa : null,
                "CargoCodigo": data.GET_PRODUCTO_VISA_PRODUCTO_ID.UsoATM,
                "EsTarjetaTemporal": 0,
                "PorcentajeLimiteCompra": data.PorcentajeLimiteCompra ? data.PorcentajeLimiteCompra : 0,
                "PorcentajeLimiteCompraCuotas": data.PorcentajeLimiteCompraCuotas ? data.PorcentajeLimiteCompraCuotas : 0,
                "PorcentajeLimiteAdelantos": data.PorcentajeLimiteAdelantos ? data.PorcentajeLimiteAdelantos : 0,
                "Cuit":data.cliente.Cuit,
                "HabilitacionCajerosId":data.habilitacionCajerosId
    
            }
            
            switch (mode) {
                case 'edit':
                    CuentaTarjetaCreditoVisa.TarjetaCreditoId = data.TarjetaCreditoId;
                    CuentaTarjetaCreditoVisa.Id = data.TarjetaCreditoVisaId;
                    break;
            }
    
            if(!data.Empresa || data.Empresa == null){
                localValues.TarjetaCreditoVisa.push(CuentaTarjetaCreditoVisa); 
                localValues.CuentaTarjetaCreditoVisa.push(CuentaTarjetaCreditoVisa);
            }
        }
        
        if(Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length > 0 ){

            for(var i=0;i<data.cuentasAdicionales.length;i++){

                if(data.cuentasAdicionales[i].ClienteTarjetas){
                    var dateBirthdayAdic = soloAdicionales && mode == 'edit' ? null : convertDateBirthday(data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.FechaNac);
                    let fechaNac;
                    let fechaAux;

                    if(data.cuentasAdicionales[i].ClienteTarjetas && data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes){
                        fechaNac = data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.FechaNac;
                        fechaAux = ((fechaNac.slice(6,8)) + "/"+ (fechaNac.slice(4,6)) + "/"+  (fechaNac.slice(0,4)))  
                        fechaAux = new Date(fechaAux);
                    }
    
                    let CuentaTarjetaCreditoVisaAdicional = {
                        "Id": null,
                        "TarjetaCreditoId": null,
                        "DocumentoTipoCodigoVisa": data.cuentasAdicionales[i].ClienteTarjetas ? data.cuentasAdicionales[i].ClienteTarjetas.documentoCodigoVisa : null,
                        "DocumentoNumero": data.cuentasAdicionales[i].ClienteTarjetas ? data.cuentasAdicionales[i].ClienteTarjetas.NUMERO_DOCUMENTO : null,
                        "NacionalidadCodigoVisa": data.cuentasAdicionales[i].ClienteTarjetas ? data.cuentasAdicionales[i].ClienteTarjetas.nacionalidadVisa : null,
                        "SexoCodigoVisa": data.cuentasAdicionales[i].ClienteTarjetas ? data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.Sexo : null,
                        "EstadoCivilCodigoVisa": data.cuentasAdicionales[i].ClienteTarjetas ? data.cuentasAdicionales[i].ClienteTarjetas.estadoCivilVisa : null,
                        "OcupacionCodigoVisa": data.cuentasAdicionales[i].ClienteTarjetas ? data.cuentasAdicionales[i].ClienteTarjetas.ocupacionVisa : null,
                        "CargoCodigo": data.cuentasAdicionales[i].usoCajerosConCargo ? data.cuentasAdicionales[i].usoCajerosConCargo : ((data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.UsoATM) ? data.GET_PRODUCTO_VISA_PRODUCTO_ID.UsoATM : null),
                        "EsTarjetaTemporal": data.cuentasAdicionales[i].seleccionaTarjetaTemporal,
                        "PorcentajeLimiteCompra":data.cuentasAdicionales[i].LimiteDeCompra ? data.cuentasAdicionales[i].LimiteDeCompra : 100,
                        "PorcentajeLimiteCompraCuotas": data.cuentasAdicionales[i].LimiteDeCEC ? data.cuentasAdicionales[i].LimiteDeCEC : 0,
                        "PorcentajeLimiteAdelantos": data.cuentasAdicionales[i].LimiteDeAdelantos ? data.cuentasAdicionales[i].LimiteDeAdelantos : 0,
                        "PorcentajeLimiteTransaccion": data.cuentasAdicionales[i].SeleccionLimiteTransaccionClienteAdicional ? data.cuentasAdicionales[i].LimitePorTransaccion : null,
                        "Cuit": data.cuentasAdicionales[i].ClienteTarjetas.Cuit,
                        "Area":data.cuentasAdicionales[i].codigoAreaCentroDeCostos ? data.cuentasAdicionales[i].codigoAreaCentroDeCostos : null,
                        "Sector": data.cuentasAdicionales[i].codigoSectorCentroDeCostos ? data.cuentasAdicionales[i].codigoSectorCentroDeCostos : null,
                        "HabilitacionCajerosId":data.cuentasAdicionales[i].HabilitacionCajeroId,
                        "FechaNacimiento": fechaAux ? fechaAux : null
                    }
                    
                    switch (mode) {
                        case 'edit':
                            CuentaTarjetaCreditoVisaAdicional.TarjetaCreditoId = data.cuentasAdicionales[i].IdAdicional;
                            CuentaTarjetaCreditoVisaAdicional.Id = data.cuentasAdicionales[i].TarjetaCreditoVisaId;
                            CuentaTarjetaCreditoVisaAdicional.Delete = data.cuentasAdicionales[i].Delete && data.cuentasAdicionales[i].Delete ;
                            break;
                        case 'create':
                            CuentaTarjetaCreditoVisaAdicional.FechaNacimiento = data.cuentasAdicionales[i].ClienteTarjetas ? new Date(dateBirthdayAdic.anioFechaNac, dateBirthdayAdic.mesFechaNac, dateBirthdayAdic.diaFechaNac) : null
                    }
    
                    localValues.TarjetaCreditoVisa.push(CuentaTarjetaCreditoVisaAdicional);
                }
                
            }
        }


        
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} feature
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, feature, sagasCallback, viewCallback) {

        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", feature);
        RestApiProxy.SetApiUrl();
        SagasProxy.Execute(sagasCallback, undefined, viewCallback, feature);
    }

    function agregarCuentaTarjetaCreditoCabal(data, mode, soloAdicionales) {

        if(!soloAdicionales){
            var dateBirthday = convertDateBirthday(data.cliente.DatosClientes.FechaNac);
    
            let cuentaTarjetaCreditoCabal = {
                "Id": data.TarjetaCreditoCabalId,
                "TarjetaCreditoId": data.TarjetaCreditoId,
                "NombreTitular": data.cliente.APELLIDO + " " + data.cliente.NOMBRE,
                "SexoCodigo": data.cliente.DatosClientes.Sexo,
                "EstadoCivilCodigo": data.cliente.estadoCivilCabalDoc,
                "ProfesionCodigo": (data.cliente.ocupacionCabalDoc && data.cliente.ocupacionCabalDoc.length<3) ? data.cliente.ocupacionCabalDoc : null,
                "DocumentoTipoCodigo": data.cliente.codigoCabalDoc,
                "DocumentoNumero": data.cliente.NUMERO_DOCUMENTO,
                "ComponenteCuenta": "01", //titular
                "CausaTarjeta": "00", //normal
                "DenuncianteCodigo": null,
                "TarjetaCreditoIdAnterior": null,
                "LimiteCompra": data.limiteCompra,
                "FechaNacimiento": new Date(dateBirthday.anioFechaNac, dateBirthday.mesFechaNac, dateBirthday.diaFechaNac),
                "FechaBloqueo": null,
                "HoraBloqueo": null,
                "Cuit":data.cliente.Cuit
            };
    
            if(!data.Empresa || data.Empresa == null){
                localValues.CuentaTarjetaCreditoCabal.push(cuentaTarjetaCreditoCabal);
                localValues.TarjetaCreditoCabal.push(cuentaTarjetaCreditoCabal);
            }
        }

        if(Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length > 0 ){

            for(var i=0;i<data.cuentasAdicionales.length;i++){

                if(data.cuentasAdicionales[i].ClienteTarjetas){
                    var dateBirthdayAdic = convertDateBirthday(data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.FechaNac);
    
                                   
    
                    let cuentaTarjetaCreditoCabalAdic =  {
                        "Id": data.cuentasAdicionales[i].TarjetaCreditoCabalId,
                        "TarjetaCreditoId": data.cuentasAdicionales[i].IdAdicional,
                        "NombreTitular": data.cuentasAdicionales[i].ClienteTarjetas.APELLIDO + " " + data.cuentasAdicionales[i].ClienteTarjetas.NOMBRE,
                        "SexoCodigo": data.cuentasAdicionales[i].ClienteTarjetas.DatosClientes.Sexo,
                        "EstadoCivilCodigo": data.cuentasAdicionales[i].ClienteTarjetas.estadoCivilCabalDoc,
                        "ProfesionCodigo": (data.cuentasAdicionales[i].ClienteTarjetas.ocupacionCabalDoc && data.cuentasAdicionales[i].ClienteTarjetas.ocupacionCabalDoc.length < 3) ? data.cuentasAdicionales[i].ClienteTarjetas.ocupacionCabalDoc : null,
                        "DocumentoTipoCodigo": data.cuentasAdicionales[i].ClienteTarjetas.codigoCabalDoc,
                        "DocumentoNumero": data.cuentasAdicionales[i].ClienteTarjetas.NUMERO_DOCUMENTO,
                        "ComponenteCuenta": "01", //titular
                        "CausaTarjeta": "00", //normal
                        "DenuncianteCodigo": null,
                        "TarjetaCreditoIdAnterior": null,
                        "LimiteCompra": (parseInt(data.cuentasAdicionales[i].LimiteDeCompra) <= parseInt(data.limiteCompra)) ? data.cuentasAdicionales[i].LimiteDeCompra : data.limiteCompra,
                        "FechaNacimiento": new Date(dateBirthdayAdic.anioFechaNac, dateBirthdayAdic.mesFechaNac, dateBirthdayAdic.diaFechaNac),
                        "FechaBloqueo": null,
                        "HoraBloqueo": null,
                        "Cuit":data.cuentasAdicionales[i].ClienteTarjetas.Cuit
                    };
    
                    if(mode == "edit"){
                        cuentaTarjetaCreditoCabalAdic.Delete = data.cuentasAdicionales[i].Delete && data.cuentasAdicionales[i].Delete;
                    }
            
                    localValues.CuentaTarjetaCreditoCabal.push(cuentaTarjetaCreditoCabalAdic);
                    localValues.TarjetaCreditoCabal.push(cuentaTarjetaCreditoCabalAdic);
                }

            }
        }

    }

    function agregarCuentaTarjetaCabal(data, extension, mode) {
        let productoCabal = data.GET_PRODUCTO_CABAL_PRODUCTO_ID;
        var senialPrEmision = 0;
        var activacionTelefonica = null;
        var altaPosdatada = "N";
        var retencionTarjeta = "N";
        var segmentoCartera;
        var marcaCompartida;
        var topePagoMaximo;

        if (productoCabal != null && productoCabal.PreEmision != null) {
                senialPrEmision = data.preEmisionId == "1";
                activacionTelefonica = data.preEmisionId == "1" ? (data.GET_PRODUCTO_CABAL_PRODUCTO_ID.ActivacionTelefonica  ? 1 : 0): null;
                altaPosdatada = data.altaPosDatadaId;
                retencionTarjeta = data.retencionTarjetaId; //normal : a cargo de la entidad
                segmentoCartera = data.segmentoCarteraSeleccionadoId ? data.segmentoCarteraSeleccionadoId : null;
                marcaCompartida = data.marcaCompartidaSeleccionadaId ? data.marcaCompartidaSeleccionadaId : null;
                topePagoMaximo = data.topePagoMinimo ? data.topePagoMinimo : null;
        }

        let cuentaTarjetaCabal = {
            "FechaCierreBalance": null,
            "PrimerVencimientoAgroCabal": null,
            "SegundoVencimientoAgroCabal": null,
            "SegmentoCarteraId": segmentoCartera,
            "MarcaCompartidaId": marcaCompartida,
            "SenialPreEmision": senialPrEmision,
            "ActivacionTelefonica": activacionTelefonica,
            "AltaPosdatada": altaPosdatada,
            "RetencionTarjeta": retencionTarjeta,
            "TopePagoMinimo": topePagoMaximo,
            "TarjetasAdicionales": Array.isArray(data.cuentasAdicionales) ? data.cuentasAdicionales.length : 0,
            "MarcaAgroCabal": null,
            "MarcaRenovacion": 1,
            "AniosAplicaBonificacion": 9,
            "PaisEmisionCodigo": " ",
            "MotivoBajaCodigo": null,
            "FormaEnvioResumen": data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'EMAIL') ? 2 : 0,
            "VinculacionCodigo": null,
            "CalculaCargosEIntereses": "000",
            "CausaEstado": "00",
            "BajaCodigo": "0",
            "IvaCategoriaCodigo": data.cliente.ivaCabal,
            "CicloFacturacionAnterior": null,
            "PorcReduccionRenovacion": "0",
            "FechaVencimientoCuenta": null,
            "FechaBaja": null,
            "FechaActivacionPreEmitida": null,
            "NumeroSocio": data.cliente.CuentaCliente,
            "ClaveBUP": null
        }

        switch (mode) {
            case 'create':
                cuentaTarjetaCabal.CuentaTarjetaId = null;
                cuentaTarjetaCabal.Telefono = null;
                break;
            case 'edit':
                cuentaTarjetaCabal.SegmentoCartera = data.GET_PRODUCTO_CABAL_PRODUCTO_ID.AsociaSegmentoCartera ? data.GET_PRODUCTO_CABAL_PRODUCTO_ID.AsociaSegmentoCartera : null;
                cuentaTarjetaCabal.MarcaCompartida = data.DatosSolicitud.MarcaCompartida ? data.MarcaCompartida : null;
                cuentaTarjetaCabal.TopePagoMinimo = data.DatosSolicitud.TopePagoMinimo ? data.TopePagoMinimo : null;
                cuentaTarjetaCabal.TarjetasAdicionales = Array.isArray(data.cuentasAdicionales) ? data.cuentasAdicionales.length : 0;
                cuentaTarjetaCabal.FormaEnvioResumen = data.ATLAS_TIPO_COMUNICACION.filter(x => x.CODIGO.toUpperCase() == 'EMAIL') ? 2 : 0
                cuentaTarjetaCabal.IvaCategoriaCodigo = data.GET_ATLAS_CATEGORIA_IVA_CODIGO_CLIENTE ? data.GET_ATLAS_CATEGORIA_IVA_CODIGO_CLIENTE.VALOR_X : null;
                break;
        }

        if (mode == 'edit' && !extension) {
            cuentaTarjetaCabal.Id = data.DatosSolicitud.CuentaTarjetaCabalId;
            cuentaTarjetaCabal.CuentaTarjetaId = data.CuentaTarjetaId;
        }
        else if (mode == 'edit') {
            cuentaTarjetaCabal.Id = extension.CuentaTarjetaCabalId ? extension.CuentaTarjetaCabalId : null;
            cuentaTarjetaCabal.CuentaTarjetaId = extension.CuentaTarjeta ? extension.CuentaTarjeta.Id : null;
        }

        localValues.Solicitud.CuentaTarjetaCabal.push(cuentaTarjetaCabal);
    }

    /**
    * 
    * @param {any} data
    */
    //Funcion que segmenta la Fecha de Nacimiento por año, mes y dia
    function convertDateBirthday(data) {
        let mes = 0;
        mes = data.slice(4, 6) - 1;

        let dateBirthday = {
            anioFechaNac: data.slice(0, 4),
            mesFechaNac: mes.toString(),
            diaFechaNac: data.slice(6, 8)
        }

        return dateBirthday;
    }

    return {
        GuardarSolicitud: function (data, sagasCallback, viewCallback, executionContext) {
            return _guardarSolicitud(data, sagasCallback, viewCallback, executionContext);
        },
        GuardarSolicitudBorrador: function (data, viewCallBack) {
            return _guardarSolicitudBorrador(data, viewCallBack);
        },
        ModificarSolicitud: function (data, sagasCallback, viewCallback, executionContext) {
            return _modificarSolicitud(data, sagasCallback, viewCallback, executionContext);
        },
        ModificarSolicitudAdicionales: function (data, sagasCallback, viewCallback, executionContext) {
            return _modificarSolicitudAdicionales(data, sagasCallback, viewCallback, executionContext);
        },
        NuevaSolicitudAdicionales: function (data, sagasCallback, viewCallback, executionContext) {
            return _nuevaSolicitudAdicionales(data, sagasCallback, viewCallback, executionContext);
        }
    }
};

let solicitudManager = new SolicitudManager();

module.exports = solicitudManager;


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Common/Managers/SolicitudManager.js